import {useState, useEffect} from 'react'
import {motion} from 'motion/react'
import medalha from '../../assets/imagens/medalha.png'
import XP from '../../assets/imagens/icone_XP.png'

import './RankingList.css'
export default function RankingList({ranking, setRanking}){

    return(
        <div className="rankingLista">
            <h1>Ranking - TOP 15</h1>
            <div className='cabecalhoRakingLista'>
                <p>Posição</p>
                <p>Nome</p>
                <p>Empresa</p>
                <p className="score">Pontuação</p> 
                <p className="hidden" >Chamados Resolvidos</p>
                <p className="hidden">Email</p>
            </div>
          <div className='areaList'>
            {ranking.map((u, index)=>(
            <motion.div 
                whileHover={{scale:1.02, cursor:'pointer', backgroundColor:"var(--background)"}}
                    transition={{
                    type: "spring",
                    duration:1
                }}
                className="linha"
                key={index}>

                    {index < 5 && 
                        <img src={medalha} width={25} className='medalha'/>
                    }

                    <p className='numero'>{index + 1}</p>

                    <p>{u.name}</p>
                    <p className="location">{u.location}</p>

                    <div className='flex  score'>
                        <img src={XP} width={18} />
                        <p className='numero'>{u.score}</p> 
                    </div>

                    <p className='numero hidden'>{u.ticketsSolved}</p>
                    
                    <p className="hidden">{u.email} </p>

            </motion.div>               
          ))}
          </div>
        </div>
    )    
}